export const PARKS_AVAILABLE = "PARKS_AVAILABLE";
export const BIKES_AVAILABLE = "BIKES_AVAILABLE";


// WEBPACK FOOTER //
// ./src/config/constants.js